import MegaphoneIcon from '@atlaskit/icon/core/megaphone';
import React from 'react';

export const SvgMegaphone = () => (
  <MegaphoneIcon label="" testId="ads-refreshed-icon" />
);
